<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hhnFWr/tc-custom/9781488078415.jpg?1743820632826" alt="This image is the cover for the book Together Again?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Together Again?
      </h1>
      <p class="bookDescription body article font2">
        <i>Don’t miss this fateful reader-favorite novella by New York Times bestselling author Jill Shalvis.</i><br/><br/>Accountant Chloe Cooper laughs when a fortune teller predicts that her life is about to be transformed by true love—and that her karma is about to take a nosedive. Until Chloe walks straight into her former lover, FBI agent Ian McCall.<br/><br/>Ian is even more handsome and more built than he was before, and neither can deny that the attraction between them is still intense. But Ian is being very secretive about why he’s suddenly back in Chloe’s life. Is this the fortune teller’s first prediction coming true…or the second?<br/><br/>Originally published in the 2007 Jinx anthology.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jill Shalvis
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author <B>Jill Shalvis</B> is the award winning author of over three dozen romance novels.&#160; Visit www.jillshalvis.com for a complete book list and a daily blog chronicling her I-Love-Lucy attempts at having it all; the writing, the kids, a life ...</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b66e56e4